import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import { handleError, handleResponse } from '@/services/api/utils/response.js'
import axios from 'axios'

const url = 'v1/master-data-upload'

const masterDataManagement = new ApiCore({
    index: true,
    url: url
})

masterDataManagement.getMasterData = (params) => {
    return axios
        .get(`${apiProvider.BASE_URL}/${url}`, { params })
        .then(handleResponse)
        .catch(handleError);
}

masterDataManagement.getMasterDataEntityDetails = (id, params) => {
    return axios
        .get(`${apiProvider.BASE_URL}/${url}/${id}`, { params })
        .then(handleResponse)
        .catch(handleError);
}

masterDataManagement.downloadCSVTemplateMasterData = (entityId, type) => {
    return axios
        .get(`${apiProvider.BASE_URL}/${url}/${entityId}/${type}`)
        .then(handleResponse)
        .catch(handleError);
}

masterDataManagement.updateMasterData = (params) => {
    return axios
        .put(`${apiProvider.BASE_URL}/${url}/update-entity-data/${params.entityId}`, params)
        .then(handleResponse)
        .catch(handleError);
}


export default masterDataManagement
